import { Injectable, signal } from '@angular/core';
import { LoginSteps } from './login-layout-step';




@Injectable({ providedIn: 'root' })
export class LoginStepService {
  readonly steps = LoginSteps;
  currentStep = signal<number>(this.steps.default);
  // currentStep = signal<number>(this.steps.calculator);

  nextStep() {
    const next = this.currentStep() + 1;
    if (next <= Object.keys(this.steps).length) {
      this.currentStep.set(next);
    }
  }

  prevStep() {
    const prev = this.currentStep() - 1;
    if (prev >= 1) {
      this.currentStep.set(prev);
    }
  }

  isStep(stepKey: keyof typeof LoginSteps): boolean {
    return this.currentStep() === this.steps[stepKey];
  }

  getStepKeyByValue(value: number): keyof typeof this.steps | undefined {
    return (Object.keys(this.steps) as Array<keyof typeof this.steps>).find(
      (key) => this.steps[key] === value
    );
  }
  resetSteps() {
    this.currentStep.set(this.steps.default);
  }
}
